export default __webpack_public_path__ + "static/media/88.366236a9.jpeg";